var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4523 0.5C20.3199 0.5 25.9126 6.10781 25.9126 13.0072C25.9126 19.8922 20.3199 25.5 13.4523 25.5C6.58465 25.5 0.991943 19.8922 0.991943 13.0072C0.991943 6.10781 6.58465 0.5 13.4523 0.5ZM12.033 8.03738C11.7684 8.03738 11.5159 8.09768 11.2753 8.21828C10.9746 8.38712 10.7341 8.65244 10.6018 8.96599C10.5176 9.18307 10.3853 9.8343 10.3853 9.84636C10.253 10.5579 10.1808 11.7156 10.1808 12.994C10.1808 14.2132 10.253 15.3215 10.3612 16.0451C10.3733 16.0572 10.5056 16.8652 10.6499 17.1425C10.9145 17.6491 11.4317 17.9626 11.9849 17.9626H12.033C12.3939 17.9506 13.1516 17.637 13.1516 17.6249C14.4265 17.0943 16.9402 15.4421 17.9505 14.3447L18.0226 14.2723C18.1549 14.1397 18.3233 13.9346 18.3594 13.8864C18.5519 13.6331 18.6481 13.3196 18.6481 13.0072C18.6481 12.6563 18.5398 12.3307 18.3354 12.0654C18.2872 12.0171 18.1068 11.8121 17.9385 11.6433C16.9522 10.582 14.3784 8.84539 13.0313 8.31476C12.8268 8.23155 12.3097 8.04945 12.033 8.03738Z",
    fill: "#5DE094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9dab09372d33e3cb46e2f3ff9c88cca7.svg";
export { ForwardRef as ReactComponent };